
import React, { useEffect, useState, useRef } from "react";
import Navbar from "../../Navbar/Navbar";
import axios from "axios";
import baseURL from "../../config";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaEdit, FaUserCircle, FaSyncAlt, FaSearch } from "react-icons/fa";
import ContractModal from "./ContractModal.jsx";
import UserModal from "./UserModal/UserModal.jsx";
import { EditNote } from "@mui/icons-material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CircularProgress from '@mui/material/CircularProgress';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  TextField,
  TablePagination,
  InputAdornment,
  RadioGroup,
  FormControlLabel,
  Radio,
  Alert,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import AssignmentIcon from "@mui/icons-material/Assignment";
import TouchAppIcon from '@mui/icons-material/TouchApp';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const ContractTable = () => {
  // State variables
  const [contracts, setContracts] = useState({ contracts: [] });
  const { id: crewingAgentId } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [statusHistory, setStatusHistory] = useState([]);
  const [showUserModal, setShowUserModal] = useState(false);
  const [crewingAgent, setCrewingAgent] = useState([]);
  const [updatedbankDetails, setUpdatedBankDetails] = useState({});
  const navigate = useNavigate();
  const [openBankModal, setOpenBankModal] = useState(false);
  const [bankDetails, setBankDetails] = useState({
    BankHolderName: '',
    bankName: '',
    accountNumber: '',
    ifscCode: '',
    branchName: '',
    bankAdress: '',
  });

  const [isLoading, setIsLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false); // Separate loading state for search
  const [openModal, setOpenModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDocuments, setModalDocuments] = useState([]);
  const [selectedApprovals, setSelectedApprovals] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState(null);
  const [selectedFee, setSelectedFee] = useState(null);

  // Pagination State
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalContracts, setTotalContracts] = useState(0);
  const [feeModalOpen, setFeeModalOpen] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [reason, setReason] = useState("");

  const searchInputRef = useRef(null);
  const searchTimeoutRef = useRef(null);

  const fetchContracts = async (withSearch = false) => {
    const token = localStorage.getItem("token");
    try {
      if (withSearch) {
        setSearchLoading(true); // Only show search loading for search operations
      } else {
        setIsLoading(true); // Show full loading for initial/pagination loads
      }

      let endpoint;
      if (crewingAgentId) {
        endpoint = `/api/getContractDetailsByAgent/${crewingAgentId}?page=${page + 1}&limit=${rowsPerPage}`;
        if (searchTerm.trim()) {
          endpoint += `&search=${encodeURIComponent(searchTerm.trim())}`;
        }
      } else {
        endpoint = `/api/getAllContractData?page=${page + 1}&limit=${rowsPerPage}`;
        if (searchTerm.trim()) {
          endpoint += `&search=${encodeURIComponent(searchTerm.trim())}`;
        }
      }

      const response = await axios.get(`${baseURL}${endpoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("data", response?.data)

      if (response.data) {
        setContracts(response?.data?.contracts || 0);
        setTotalContracts(response.data.totalContracts || 0);
      }
    } catch (error) {
      console.error("Error fetching contract details:", error?.response?.data?.message);
      setError(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
      setSearchLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const displayNames = {
    pipolicydocument: "P&I Certificate",
    maritimelabourconvention: "Maritime Labour Convention",
    fsdocument: "Financial Security Document",
    dmlcp1: "DMLC Part 1",
    dmlc2: "DMLC Part 2",
    registryDocument: "Vessel Registry Document",
    SMD: "Safe Management Document",
    Cargo_PassengerShipSafety: "Cargo Passenger Ship Safety",
  };


  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Improved search handling with proper debouncing
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    // Clear any existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Set a new timeout
    searchTimeoutRef.current = setTimeout(() => {
      setPage(0); // Reset to first page when search term changes
      fetchContracts(true); // true indicates this is a search operation
    }, 500);
  };


  // Handle search input key press (Enter)
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      setPage(0);
      fetchContracts(true);
    }
  };


  // Handle manual search button click
  const handleSearchClick = () => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    setPage(0);
    fetchContracts(true);
  };


  // Clear search with focus maintained
  const handleClearSearch = () => {
    setSearchTerm("");
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    setPage(0);
    // Use setTimeout to ensure the state update completes before fetching
    setTimeout(() => {
      fetchContracts(true);
      // Maintain focus after clearing
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, 0);
  };


  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);


  // Bank Details
  const BankDetails = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${baseURL}/api/CrewinngAccount/CrewingAgentADetailsccount/${crewingAgentId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    setUpdatedBankDetails(response.data.data)
  }


  const handleOpenHistory = async (contractId) => {
    try {
      const response = await axios.get(
        `${baseURL}/api/contract-statusById/${contractId}`
      );


      if (response.data.success) {
        setStatusHistory(response.data.data.statusHistory || []);
        setShowModal(true);
      } else {
        console.error("Error fetching contract status:", response.data.message);
      }
    } catch (error) {
      console.error(
        "Failed to fetch contract status:",
        error.response?.data?.message || error.message
      );
    }
  };


  const handleOpenModal = (title, docs) => {
    setModalTitle(title);
    setModalDocuments(docs);
    setOpenModal(true);
  };


  useEffect(() => {
    fetchContracts();

    if (crewingAgentId) {
      fetchCrewingAgent();
      BankDetails();
    }
  }, [crewingAgentId, page, rowsPerPage]); // Re-fetch when pagination changes


  //fetch CrewingAgents details
  const fetchCrewingAgent = async () => {
    if (!crewingAgentId) {
      console.error("Crewing Agent ID is undefined, skipping API call.");
      return;
    }
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${baseURL}/api/getCrewingAgentsDetailsById/${crewingAgentId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      setCrewingAgent(response.data);
    } catch (error) {
      console.error("Error fetching crewing Agents details:", error.message);
    }
  };

  const handleApprovalChangeadmin = (contractId, value) => {
    setSelectedApprovals((prev) => ({
      ...prev,
      [contractId]: value,
    }));
  };


  const handleOpenUpdateForm = (contract) => {
    navigate(`/ContractUpdate/${contract._id}`);
  };

  //========hnadle download excel for download the execl report of contracts=========
  const handleDownloadExcelContract = async () => {
    try {
      const res = await axios.get(
        `${baseURL}/api/getContractDetailsForExcelReport`
      );

      const data = res.data.contractDetails;
      console.log("Date", data)
      const formatDate = (date) => {
        if (!date) return "";
        return new Date(date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });
      };

      // Map the data to a flat structure for Excel
      const excelData = data.map((item) => ({
        "Created Date": formatDate(item.createdAt),
        "Vessel Name": item.ShipDetails?.vesselname || "",
        "Crew Name": Array.isArray(item.crewdetails)
          ? item.crewdetails.map((c) => c.name).join(", ")
          : item.crewdetails?.name || "",
        "Crew INDOS No": Array.isArray(item.crewdetails)
          ? item.crewdetails.map((c) => c.indosno).join(", ")
          : item.crewdetails?.indosno || "",
        "Vessel Owner": item.vesselOwner?.company_name || "",
        "Crewing Agent": item.crewingAgent?.agentName || "",
        "id": item._id || "",
      }));

      console.log("exporteddata", excelData)
      // Create a worksheet
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Contracts");

      // Write workbook and save
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, "ContractDetails.xlsx");
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };


  const handleSubmit = async (contractId, crewingAgentId) => {
    const approvalStatus = selectedApprovals[contractId];


    if (!approvalStatus) {
      toast.error("Please select a status before submitting.");
      return;
    }


    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(`${baseURL}/api/contract-status`, {
        contractId,
        crewingAgentId,
        crewingAgentStatus: null,
        adminStatus: approvalStatus,
        approvedBy: "Admin",
        updatedAt: new Date().toISOString(),
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });


      if (response.status === 201) {
        toast.success("Status updated successfully!");
        fetchContracts(); // Refresh data instead of window.location.reload()
      }
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status.");
    }
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem("token");

      const payload = {
        contractId: selectedFee?.[0].contractId,
        crewingAgentId: selectedFee?.[0].crewingAgentId,
        fee: {
          isApproved: approvalStatus === "Approved",
          reasonForNotApproved:
            approvalStatus === "Not Approved" ? reason : "",
        },
      };

      const response = await axios.post(
        `${baseURL}/api/contract-status`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("Fee approval saved:", response.data);
      toast.success("Fee status updated successfully!");
      handleCloseFeeModal();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error saving fee status:", error);
      toast.error("Failed to update fee status.");
    }
  };

  const ApprovalhandleChange = (e) => {
    setApprovalStatus(e.target.value);
    if (e.target.value === "Approved") {
      setReason("");
    }
  };

  const handleEdit = (contract) => {
    navigate("/EditContractTable", {
      state: {
        contract: contract,
        crewingAgentId: crewingAgentId,
      },
    });
  };


  const handleApprovalChange = async (contractId, isApproved) => {
    try {
      const token = localStorage.getItem("token");


      const response = await axios.post(
        `${baseURL}/api/approvecontract/${contractId}`,
        { isApproved },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      if (response.status === 200) {
        toast.success("Contract approval status updated");
        fetchContracts(); // Refresh data instead of manipulating state directly
      }
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error updating approval status:", error.response?.data || error.message);
      toast.error("Failed to update approval status");
    }
  };


  const setShowBankModal = () => {
    setOpenBankModal(true);
  };

  const handleOpenFeeModal = (fee) => {
    setSelectedFee(fee);
    setFeeModalOpen(true);
  };

  const handleCloseFeeModal = () => {
    setFeeModalOpen(false);
  };


  const handleCloseBankModal = () => {
    setOpenBankModal(false);
    setBankDetails({
      BankHolderName: '',
      bankName: '',
      accountNumber: '',
      ifscCode: '',
      branchName: '',
      bankAdress: '',
    });
  };


  const handleBankInputChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prevData) => ({ ...prevData, [name]: value }));
  };


  const handleBankSubmit = async () => {
    const payload = {
      BankHolderName: bankDetails.BankHolderName,
      crewingAgentId: crewingAgentId,
      accountNumber: bankDetails.accountNumber,
      bankName: bankDetails.bankName,
      ifscCode: bankDetails.ifscCode,
      branchName: bankDetails.branchName,
      bankAdress: bankDetails.bankAdress,
    }

    const token = localStorage.getItem("token");
    try {
      await axios.post(`${baseURL}/api/CrewinngAccount/CrewingAgentAccount`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Bank details saved successfully");
      handleCloseBankModal();
      BankDetails(); // Refresh bank details
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (err) {
      console.error("Error saving bank details:", err);
      toast.error("Failed to save bank details");
    }
  }
  const handleSignInSignOffClick = () => {
    navigate(`/SignInSignOff/${crewingAgentId}`, {
      state: { openFormI: true }, // ✅ pass state
    });
  };

  return (
    <>
      <div>
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '16rem',
            }}
          >
            <CircularProgress color="primary" size={60} thickness={5} />
          </Box>
        ) : (
          <div>
            <Navbar />
            {error && (
              <Box p={4} textAlign="center" bgcolor="#fdecea" color="#b71c1c">
                <Typography color="error" variant="h6">
                  {error}
                </Typography>
              </Box>
            )}
            <Box sx={{ marginTop: 2, padding: 2 }}>
              {/* Flex container for title and button */}
              <Box display="flex" justifyContent="center" alignItems="center" mb={2} sx={{ width: "100%" }}>
                {crewingAgentId && (
                  <Typography variant="h5" sx={{ display: "flex", alignItems: "center", textAlign: "center", color: "#FF6F00" }}>
                    {crewingAgent.agentName}
                  </Typography>
                )}
              </Box>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>


                {/* Left Side: Enhanced Search Bar */}
                <Box display="flex" gap={2}>
                  <TextField
                    inputRef={searchInputRef}
                    label="Search by Vessel, Crew, Indos No."
                    variant="outlined"
                    size="small"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    onKeyPress={handleKeyPress}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {searchLoading ? (
                            <CircularProgress size={20} />
                          ) : (
                            <IconButton onClick={handleSearchClick} size="small">
                              <FaSearch />
                            </IconButton>
                          )}
                          {searchTerm && (
                            <IconButton onClick={handleClearSearch} size="small">
                              ✕
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                {!crewingAgentId && (
                  <Box display="flex" gap={2}>
                    <Button component={Link} to="/PendingFormI" variant="contained" color="primary">
                      Pending FormI
                    </Button>
                  </Box>)}
                {!crewingAgentId && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDownloadExcelContract}
                    sx={{
                      px: 2,
                      py: 0.8,
                      borderRadius: 2,
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Download Excel
                  </Button>)}



                {crewingAgentId && (
                  <Box display="flex" gap={2}>
                    <Button component={Link} to={`/invoicecharges/${crewingAgentId}`} variant="contained" color="primary">
                      Invoice Charges
                    </Button>
                  </Box>)}

                {crewingAgentId && (
                  <Box display="flex" gap={2}>
                    <Button component={Link} to={`/SeaServiceProfile/${crewingAgentId}`} variant="contained" color="primary">
                      Seaservice
                    </Button>
                  </Box>)}

                {/* Centered Title with Icon */}
                <Typography variant="h5" display="flex" alignItems="center">
                  <AssignmentIcon sx={{ marginRight: 1, color: "#007bff" }} />
                  Contract Details
                </Typography>


                {/* Right Side: Buttons + Total Contracts + Bank Details */}
                <Box display="flex" alignItems="center" gap={2}>

                  {/* Show SignIn/SignOff and Add Contract Buttons only when crewingAgentId is NOT present */}
                  {!crewingAgentId && (
                    <Box display="flex" gap={2}>
                      <Button component={Link} to="/SignInSignOff" state={{ openFormI: true }} variant="contained" color="primary">
                        SignIn/SignOff
                      </Button>


                      <Button component={Link} to="/ContractForm" variant="contained" color="primary">
                        Add Contract
                      </Button>
                      <Button
                        component={Link}
                        to="/ContractForVesselOwner"
                        variant="contained"
                        color="primary"
                      >
                        Vessel Owner Contract
                      </Button>
                    </Box>
                  )}

                  {crewingAgentId && (
                    <Box display="flex" gap={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSignInSignOffClick}
                      >
                        SignIn / SignOff
                      </Button>
                    </Box>
                  )}

                  {/* Total Contracts Box */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, padding: "6px 12px", bgcolor: "#fff3cd", borderRadius: "8px" }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#856404" }}>
                      Total Contract:
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "#d39e00" }}>
                      {totalContracts}
                    </Typography>
                  </Box>


                  {/* Bank Details Button (only if crewingAgentId exists) */}
                  {crewingAgentId && (
                    <Button variant="contained" color="primary" onClick={() => setShowBankModal(true)}>
                      Bank Details
                    </Button>
                  )}


                  {/* User Icon (only if crewingAgentId exists) */}
                  {crewingAgentId && (
                    <IconButton onClick={() => setShowUserModal(true)}>
                      <FaUserCircle size={40} />
                    </IconButton>
                  )}
                </Box>
              </Box>

              <TableContainer component={Paper} sx={{ overflowX: "auto", width: "100%" }}>
                <Table sx={{ width: "100%", tableLayout: "fixed" }}>
                  <TableHead sx={{ backgroundColor: "#1976D2", height: "30px", overflow: "hidden" }}>
                    <TableRow>
                      <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "80px" }}>Sr. No.</TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", }}>Vessel Owner</TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "270px" }}>Crew</TableCell>
                      {!crewingAgentId && <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "175px" }}>Crewing Agent</TableCell>}
                      {crewingAgentId && <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "175px" }}>Travel Documents</TableCell>}
                      <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", }}>Status</TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "70px" }}> <TouchAppIcon /></TableCell>
                      {!crewingAgentId && (
                        <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "130px" }}>Approval</TableCell>
                      )}
                      {!crewingAgentId && (
                        <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "180px" }}>Status</TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* {console.log("contracts", contracts)} */}
                    {contracts?.length > 0 ? (
                      contracts?.map((contract, index) => (

                        <TableRow key={`${contract._id}-${index}`}>
                          <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                          {console.log("contract single", contract)}
                          <TableCell>
                            <Box sx={{ fontSize: "0.85rem", display: "flex", flexDirection: "column", gap: "4px" }}>
                              {!crewingAgentId && (<Typography>
                                <strong>Company:</strong> {contract.vesselOwner?.[0]?.company_shortname || contract.vesselOwner?.company_shortname}
                              </Typography>)}

                              <Typography>
                                <strong>Vessel:</strong> {contract.ShipDetails?.[0]?.vesselname || contract.ShipDetails?.vesselname}
                              </Typography>
                              {/* {console.log(contract)} */}
                              {crewingAgentId && (
                                <>
                                  <Typography>
                                    <strong>IMO Number :</strong> {contract.ShipDetails?.[0]?.IMO_Number || contract.ShipDetails?.IMO_Number}
                                  </Typography>
                                  <Typography>
                                    <strong>Ship Type :</strong> {contract.ShipDetails?.[0]?.vesseltype || contract.ShipDetails?.vesseltype}
                                  </Typography>
                                  <Typography>
                                    <strong>Ship Flag :</strong> {contract.ShipDetails?.[0]?.Flag || contract.ShipDetails?.Flag}
                                  </Typography>
                                  <Typography>
                                    <strong>GRT :</strong> {contract.ShipDetails?.[0]?.gross_tonage || contract.ShipDetails?.gross_tonage}
                                  </Typography>
                                  <Typography>
                                    <strong>KW :</strong> {contract.ShipDetails?.[0]?.kiloWatt || contract.ShipDetails?.kiloWatt}
                                  </Typography>
                                </>
                              )}

                              {!crewingAgentId && contract?.createdAt && (
                                <>
                                  <Typography>
                                    <strong>Contract Created At:</strong>{" "}
                                    {new Date(contract.createdAt).toLocaleDateString("en-GB", {
                                      day: "numeric",
                                      month: "short",
                                      year: "numeric",
                                    })}{" "}
                                    {new Date(contract.createdAt).toLocaleTimeString("en-US", {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: true,
                                    })}
                                  </Typography>

                                </>
                              )}
                              {!crewingAgentId && (
                                <>
                                  <Typography sx={{ marginTop: 1, fontSize: "1rem" }}>
                                    <strong>Contract Created By:</strong> {contract?.creatorIdWithName?.[0]?.name || "N/A"}
                                  </Typography>
                                  {contract?.lastUpdatedBy?.[0] && (<Typography sx={{ marginTop: 1, fontSize: "1rem" }}>
                                    <strong>Contract Updated By:</strong> {contract?.lastUpdatedBy?.[0]?.name || "N/A"}
                                  </Typography>)}
                                </>
                              )}
                              <Button
                                variant="contained"
                                color="primary"
                                sx={{ alignSelf: "flex-start", mt: 1 }}
                                onClick={() =>
                                  console.log(contract) ||

                                  handleOpenModal(
                                    `Vessel Documents - ${contract.ShipDetails?.[0]?.vesselname || contract.ShipDetails?.vesselname}`,
                                    [
                                      "pipolicydocument",
                                      "maritimelabourconvention",
                                      "fsdocument",
                                      "dmlcp1",
                                      "dmlc2",
                                      "registryDocument",
                                      "SMD",
                                      "Cargo_PassengerShipSafety",
                                    ].map((doc) => ({
                                      key: doc, // keep original for mapping
                                      name: doc, // don’t apply regex here
                                      filePath: contract?.ShipDetails?.[0]?.[doc]?.filePath || contract?.ShipDetails?.[doc]?.filePath,
                                    }))

                                  )
                                }
                              >
                                Vessel Files
                              </Button>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Name:</strong>{" "}
                              {contract.crewdetails?.[0]?.name || contract.crewdetails?.name}
                            </Typography>
                            <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Indos No.:</strong>{" "}
                              {contract.crewdetails?.[0]?.indosno || contract.crewdetails?.indosno}
                            </Typography>
                            <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Email:</strong>{" "}
                              {contract.crewdetails?.[0]?.email || contract.crewdetails?.email}
                            </Typography>
                            <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Rank:</strong>{" "}
                              {contract.crewdetails?.[0]?.rankname || contract.crewdetails?.rankname}
                            </Typography >
                            {/* contract Duration */}
                            {contract?.contractDuration && <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Contract Duration:</strong>{" "}
                              {contract?.contractDuration || "N/A"}
                            </Typography >}
                            {/* Button to Open Modal with Crew Documents */}
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={() =>
                                handleOpenModal(
                                  `Crew Documents - ${contract.crewdetails?.[0]?.name || contract.crewdetails?.name} - ${contract.crewdetails?.[0]?.indosno || "N/A"}`,
                                  [
                                    // Existing list (already present)
                                    { key: "crewDocument", label: "Crew CV" },
                                    { key: "passportDocument", label: "Passport" },
                                    { key: "cdcDocument", label: "CDC" },
                                    { key: "stcwDocument", label: "STCW" },
                                    { key: "stsdsdDocument", label: "STSDSD" },
                                    { key: "pscrbDocument", label: "PSCRB" },
                                    { key: "watchkeepingDocument", label: "Watchkeeping" },
                                    { key: "CopDocument", label: "COP" },
                                    { key: "yellowfeverDocument", label: "YELLOW FEVER VACCINE" },
                                    { key: "CovidVaccineDocument", label: "COVID 19 VACCINE" },
                                    { key: "iloDocument", label: "ILO" },
                                    { key: "sidDocument", label: "SID" },
                                    { key: "h2sDocument", label: "H2S" },
                                    { key: "CrewPhotoDocument", label: "Crew Photo" },
                                    { key: "cookcocDocument", label: "Cook COC" },
                                    { key: "officercocDocument", label: "Officer COC" },
                                    { key: "gocDocument", label: "GOC" },
                                    { key: "gmdssDocument", label: "GMDSS" },
                                    { key: "huetDocument", label: "HUET" },
                                    { key: "highvoltageDocument", label: "High Voltage" },
                                    { key: "brmDocument", label: "BRM" },
                                    { key: "degreeDiplomaDocument", label: "Degree/Diploma" },
                                    { key: "bosietDocument", label: "BOSIET" },
                                    { key: "signContratDocument", label: "Signed Contract" },
                                    { key: "AFF", label: "Advanced Fire Fighting (AFF)" },
                                    { key: "MFA", label: "Medical First Aid (MFA)" },
                                    { key: "PSSR", label: "Personal Safety and Social Responsibility (PSSR)" },
                                    { key: "SSO", label: "Ship Security Officer (SSO)" },
                                    { key: "BTM", label: "Bridge Team Management (BTM)" },
                                    { key: "ECDIS", label: "ECDIS" },
                                    { key: "contract", label: "Contract" },
                                    { key: "BankDocument", label: "Bank Details" },
                                    // { key: "visaDocument", label: "Visa" },
                                    // { key: "ticketDocument", label: "Ticket" },
                                    { key: "watchkeepingDocumentthree", label: "Watchkeeping (3rd)" },
                                    { key: "CopDocumentthree", label: "COP (3rd)" },
                                    { key: "medicalcare", label: "Medical Care" },
                                    { key: "Foodhandling", label: "Food Handling" },
                                    { key: "FastRescueBoat", label: "Fast Rescue Boat" },
                                    { key: "HLA", label: "HLA" },
                                    { key: "ERM", label: "ERM" },
                                    { key: "COCVerification", label: "COC Verification" },
                                    { key: "GMDSSVerification", label: "GMDSS Verification" },
                                    { key: "MarlinTest", label: "Marlin Test" },
                                    { key: "PreSea", label: "Pre Sea" },
                                    { key: "GMDSSEndorsement", label: "GMDSS Endorsement" },
                                  ]
                                    .map((doc) => ({
                                      name: doc.label,
                                      filePath: contract?.crewdetails?.[0]?.[doc.key]?.filePath || contract?.crewdetails?.[doc.key]?.filePath,
                                    }))
                                    .filter((doc) => doc.filePath)
                                )
                              }
                            >
                              Crew Files
                            </Button>

                          </TableCell>
                          <TableCell>
                            <Box display="flex" flexDirection="column" alignItems="start">
                              {/* Crewing Agent Name */}
                              {!crewingAgentId && <Typography
                                sx={{
                                  mb: 1,
                                  wordBreak: "break-word",
                                  whiteSpace: "normal",
                                  // fontSize: "0.8rem",
                                  maxWidth: "175px"
                                }}
                              >
                                {contract?.crewingAgent?.[0]?.agentName || contract?.crewingAgent?.agentName}
                              </Typography>
                              }
                              {/* {console.log("contract gh", contract?.statusAfterForm1)} */}
                              {!crewingAgentId && contract?.contractStatus?.[0]?.fee &&
                                contract?.contractStatus?.[0]?.fee?.isApproved === false &&
                                contract?.contractStatus?.[0]?.latestStatus?.crewingAgentStatus === "Approve" && (<Button
                                  variant="contained"
                                  size="small"
                                  sx={{
                                    mb: 1,
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: '#fff',
                                    fontWeight: 600,
                                    fontSize: '0.875rem',
                                    textTransform: 'none',
                                    borderRadius: 2,
                                    padding: '10px 24px',
                                    minHeight: '40px',
                                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                                    border: '1px solid rgba(255, 255, 255, 0.2)',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap', // ✅ prevents wrapping
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&::before': {
                                      content: '""',
                                      position: 'absolute',
                                      top: 0,
                                      left: '-100%',
                                      width: '100%',
                                      height: '100%',
                                      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                                      transition: 'left 0.6s',
                                    },
                                    '&:hover': {
                                      background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
                                      transform: 'translateY(-2px)',
                                      boxShadow: '0 8px 25px rgba(102, 126, 234, 0.6)',
                                      '&::before': { left: '100%' },
                                    },
                                  }}
                                  onClick={() => handleOpenFeeModal(contract?.contractStatus)}
                                >
                                  💰 Fee Details
                                </Button>)}

                              {crewingAgentId &&
                                contract?.contractStatus?.[0]?.fee?.reasonForNotApproved ||
                                contract?.contractStatus?.fee?.reasonForNotApproved &&
                                (
                                  <Alert
                                    severity="warning"
                                    variant="outlined"
                                    sx={{
                                      mt: 1,
                                      borderRadius: 2,
                                      fontSize: "0.9rem",
                                      lineHeight: 1.4,
                                      display: "flex",
                                      alignItems: "center",
                                      p: 1.5,
                                      "& .MuiAlert-icon": {
                                        fontSize: "1.2rem"
                                      }
                                    }}
                                  >
                                    <Box>
                                      <Typography variant="subtitle2" fontWeight={600}>
                                        Reason for Fee Rejection:
                                      </Typography>
                                      <Typography variant="body2">
                                        {contract?.contractStatus?.[0]?.fee?.reasonForNotApproved || contract?.contractStatus?.fee?.reasonForNotApproved}
                                      </Typography>
                                    </Box>
                                  </Alert>
                                )}


                              {/* Documents Button */}
                              <Button
                                variant="contained"
                                color="primary"
                                // Only render the button if there are uploaded documents
                                style={{
                                  display: [
                                    "BSM", "RPSL", "NOK", "DrugAlcoholPolicy",
                                    "CheckList", "DeclarationForm", "TravelTicket",
                                    "Visa", "LOG", "SignedContract"
                                  ].some(type => contract[type]?.filePath) ? 'block' : 'none'
                                }}
                                onClick={() => {
                                  // Collect only uploaded documents
                                  const uploadedDocuments = [
                                    { type: "BSM", color: "primary" },
                                    { type: "RPSL", color: "secondary" },
                                    { type: "NOK", color: "success" },
                                    { type: "DrugAlcoholPolicy", color: "warning" },
                                    { type: "CheckList", color: "info" },
                                    { type: "DeclarationForm", color: "error" },
                                    { type: "TravelTicket", color: "success" },
                                    { type: "Visa", color: "warning" },
                                    { type: "LOG", color: "info" },
                                    { type: "SignedContract", color: "error" }
                                  ].filter(file => contract[file.type]?.filePath);


                                  // Open a modal or dialog to show these documents
                                  handleOpenModal(
                                    `Crewing Agent Documents - ${contract?.crewingAgent?.[0]?.agentName || contract?.crewingAgent?.agentName}`,
                                    uploadedDocuments.map(file => ({
                                      name: file.type,
                                      filePath: contract[file.type].filePath.startsWith("http")
                                        ? contract[file.type].filePath
                                        : `${baseURL}/${contract[file.type].filePath.replace(/\\/g, "/")}`
                                    }))
                                  );
                                }}
                              >
                                Documents
                              </Button>
                              {/* {console.} */}
                              {(contract?.statusAfterForm1?.[0]?.coc?.[0]?.Date || contract?.statusAfterForm1?.coc?.Date) &&
                                <Button
                                  variant="contained"
                                  sx={{
                                    mt: 2,
                                    backgroundColor: "#d32f2f", // Red color
                                    "&:hover": { backgroundColor: "#b71c1c" },
                                  }}
                                  onClick={() => navigate(`/salary-slip/${contract._id}`)}
                                >
                                  Salary Slip
                                </Button>
                              }

                            </Box>
                          </TableCell>


                          <TableCell>
                            <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Admin Status:</strong>{" "}
                              {(contract.contractStatus?.[0]?.latestStatus?.adminStatus || contract.contractStatus?.latestStatus?.adminStatus)?.toLowerCase() === "final approvel"
                                ? "Final Approval"
                                : contract.contractStatus?.[0]?.latestStatus?.adminStatus || contract.contractStatus?.latestStatus?.adminStatus}
                            </Typography>


                            <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Crewing Agent Status:</strong>{" "}
                              {contract.contractStatus?.[0]?.latestStatus?.crewingAgentStatus || contract.contractStatus?.latestStatus?.crewingAgentStatus}
                            </Typography>
                            {/* Show Animated Text if Crewing Agent Status is "Pending" */}
                            {contract.isApproved &&
                              ((!contract.contractStatus?.[0]?.latestStatus?.crewingAgentStatus &&
                                !contract.contractStatus?.latestStatus?.crewingAgentStatus) ||
                                ((contract.contractStatus?.[0]?.latestStatus?.crewingAgentStatus ||
                                  contract.contractStatus?.latestStatus?.crewingAgentStatus) !== "Approve")) && (
                                <Typography
                                  sx={{
                                    fontSize: "1rem",
                                    color: "red",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  Agent Please approve contract
                                  <ArrowForwardIcon sx={{ fontSize: "2rem", color: "red" }} />
                                </Typography>
                              )}

                            {(contract.contractStatus?.[0]?.latestStatus?.crewingAgentStatus || contract.contractStatus?.latestStatus?.crewingAgentStatus) !== "Pending" &&
                              (contract.contractStatus?.[0]?.latestStatus?.remark || contract.contractStatus?.latestStatus?.remark) && (
                                <>
                                  <Typography sx={{ fontSize: "0.85rem" }}>
                                    <strong>Remark:</strong>{" "}
                                    {contract.contractStatus?.[0]?.latestStatus.remark || contract.contractStatus?.latestStatus.remark}
                                  </Typography>
                                  <Typography sx={{ fontSize: "0.85rem" }}>
                                    <strong>Created At:</strong>{" "}
                                    {(contract.contractStatus?.[0]?.latestStatus.updatedAt || contract.contractStatus?.latestStatus.updatedAt)
                                      ? new Date(
                                        contract.contractStatus?.[0]?.latestStatus.updatedAt || contract.contractStatus?.latestStatus.updatedAt
                                      ).toLocaleString()
                                      : "N/A"}
                                  </Typography>
                                </>
                              )}

                            {!crewingAgentId && (contract?.contractStatus?.[0]?.statusHistory?.length || contract?.contractStatus?.statusHistory?.length) > 0 && (
                              <Button
                                sx={{ backgroundColor: '#2563eb', color: '#fff', '&:hover': { backgroundColor: '#1d4ed8' } }}
                                onClick={() => handleOpenHistory(contract._id)}>
                                View History
                              </Button>
                            )}


                            {(contract.contractStatus?.[0]?.formI?.filePath || contract.contractStatus?.formI?.filePath) ? (
                              // Case 1: Form I exists
                              <Typography variant="body2" color="primary" sx={{ mt: 1, fontSize: "0.85rem" }}>
                                <a
                                  href={
                                    (() => {
                                      const filePath =
                                        contract.contractStatus?.[0]?.formI?.filePath ||
                                        contract.contractStatus?.formI?.filePath;

                                      if (!filePath) return "#";

                                      const normalized = filePath.replace(/\\/g, "/");

                                      return normalized.startsWith("http")
                                        ? normalized
                                        : `${baseURL}/${normalized}`;
                                    })()
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View Form I
                                </a>


                                {/* Admin only message */}
                                {!crewingAgentId && (
                                  <>
                                    {(contract?.statusAfterForm1?.[0]?.departure?.length > 0 || contract?.statusAfterForm1?.departure?.length > 0) &&
                                      (contract?.statusAfterForm1?.[0]?.departure[0]?.date || contract?.statusAfterForm1?.departure.date) ? (
                                      <Typography sx={{ color: "green", fontWeight: "bold" }}>
                                        Crew arrival details recorded successfully.
                                      </Typography>
                                    ) : (
                                      <Typography sx={{ color: "#FF5252", fontWeight: "bold" }}>
                                        Form I uploaded. Proceed to Sign On/Sign Off for further processing.
                                      </Typography>
                                    )}
                                  </>
                                )}

                              </Typography>
                            ) : (
                              // Case 2: Form I missing
                              <>
                                {!crewingAgentId &&
                                  contract?.contractStatus?.[0]?.latestStatus?.crewingAgentStatus === "Approve" &&
                                  contract?.contractStatus?.[0]?.fee?.isApproved === false && (
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontSize: "1rem",
                                        color: "#d32f2f",
                                        fontWeight: "bold",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      Please approve fee details
                                    </Typography>
                                  )}

                                {
                                  ((contract?.contractStatus?.[0]?.latestStatus?.crewingAgentStatus ??
                                    contract?.contractStatus?.latestStatus?.crewingAgentStatus) === "Approve")
                                  &&
                                  ((contract?.contractStatus?.[0]?.fee?.isApproved ??
                                    contract?.contractStatus?.fee?.isApproved) !== false)
                                  && (
                                    <Typography
                                      variant="body2"
                                      color="error"
                                      sx={{
                                        fontSize: "1rem",
                                        color: "#FF4500",
                                        fontWeight: "bold",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      Please add Form I
                                      <ArrowForwardIcon sx={{ fontSize: "2rem", color: "#FF6347" }} />
                                    </Typography>
                                  )
                                }

                              </>
                            )}

                            {/* Add Animation in CSS */}
                            <style>
                              {`
                           @keyframes pulse {
                          0% { transform: scale(1); opacity: 1; }
                          50% { transform: scale(1.1); opacity: 0.8; }
                         100% { transform: scale(1); opacity: 1; }
                                }
                              `}
                            </style>
                          </TableCell>
                          <TableCell>
                            {!crewingAgentId && (<Tooltip title="Update contract" arrow>
                              <IconButton
                                color="primary"
                                onClick={() => handleOpenUpdateForm(contract)}


                              >
                                <FaEdit />
                              </IconButton>
                            </Tooltip>)}
                            <Tooltip title="Update Status" arrow>
                              <IconButton color="primary" onClick={() => handleEdit(contract)}>
                                <EditNote />
                              </IconButton>
                            </Tooltip>
                          </TableCell>


                          {!crewingAgentId && (
                            <TableCell>
                              {contract.isApproved ? (
                                <Typography
                                  sx={{ color: "green", fontWeight: "bold", fontSize: "0.85rem" }}
                                >
                                  Contract Approved By Admin
                                </Typography>
                              ) : (
                                <Button
                                  variant="contained"
                                  color="success"
                                  onClick={() => handleApprovalChange(contract._id, true)}
                                >
                                  Approve
                                </Button>
                              )}


                              {/* <Typography
                                sx={{ marginTop: 1, fontSize: "0.85rem", color: "text.secondary" }}
                              >
                                Created By: {contract?.creatorIdWithName?.[0]?.name || "N/A"}
                              </Typography> */}
                            </TableCell>
                          )}


                          {!crewingAgentId && (contract?.contractStatus?.[0]?.formI?.filePath || contract?.contractStatus?.formI?.filePath) && (
                            <TableCell>
                              {(contract?.contractStatus?.[0]?.latestStatus?.adminStatus === "final approvel" || contract?.contractStatus?.latestStatus?.adminStatus === "final approvel") ? (
                                <span style={{ fontWeight: "bold", color: "green" }}>Final Approved</span>
                              ) : (
                                <>
                                  <select
                                    value={selectedApprovals[contract._id] || ""}
                                    onChange={(e) =>
                                      handleApprovalChangeadmin(contract._id, e.target.value)
                                    }
                                  >
                                    <option value="">Select Status</option>
                                    <option value="Reject">Reject</option>
                                    <option value="Correction Required">Correction Required</option>
                                    <option value="final approvel">Final Approval</option>
                                  </select>


                                  <Button
                                    sx={{
                                      backgroundColor: '#2563eb',
                                      color: '#fff',
                                      '&:hover': { backgroundColor: '#1d4ed8' }
                                    }}
                                    onClick={() =>
                                      handleSubmit(contract._id,
                                        contract.crewingAgent?.[0]?._id || contract.crewingAgent?._id)}
                                  >
                                    Submit
                                  </Button>


                                </>
                              )}
                            </TableCell>
                          )}


                          {/* Rest of your table rows... (unchanged) */}
                          {/* ...Table Cell content remains the same... */}

                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          {searchTerm ? (
                            <Typography>No contracts found matching "{searchTerm}".</Typography>
                          ) : (
                            <Typography>No contracts available.</Typography>
                          )}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination Component */}
              {contracts?.length > 0 && (
                <TablePagination
                  component="div"
                  count={totalContracts}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                />
              )}
            </Box>


            {/* Modals remain unchanged */}
            {/* ContractModal, UserModal, etc. */}


            {showUserModal && (
              <UserModal
                onClose={() => setShowUserModal(false)}
                crewingAgent={crewingAgent}
                updatedbankDetails={updatedbankDetails}
              />
            )}
            {showModal && (
              <ContractModal
                onClose={() => setShowModal(false)}
                statusHistory={statusHistory ?? []}
              />
            )}


            {/* Documents Modal */}
            <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth>
              <DialogTitle>{modalTitle}</DialogTitle>
              <DialogContent>
                {modalDocuments.filter(doc => doc.filePath)?.length > 0 ? (
                  modalDocuments
                    .filter(doc => doc.filePath)
                    .map((doc, index) => (
                      <Paper
                        key={index}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          p: 2,
                          mb: 2,
                        }}
                      >
                        <Box display="flex" alignItems="center">
                          <Typography sx={{ mr: 1 }}>{index + 1}.</Typography>
                          <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                          <Typography>{displayNames[doc.name] || doc.name}</Typography>
                        </Box>

                        <Button
                          variant="contained"
                          href={
                            doc.filePath.startsWith("http")
                              ? doc.filePath
                              : `${baseURL}/${doc.filePath.replace(/\\/g, "/")}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download
                        </Button>
                      </Paper>
                    ))
                ) : (
                  <Typography textAlign="center" color="textSecondary">
                    No documents available
                  </Typography>
                )}

              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenModal(false)}>Close</Button>
              </DialogActions>
            </Dialog>


            {/* Bank Details Modal */}
            <Dialog open={openBankModal} onClose={handleCloseBankModal} maxWidth="sm">
              <DialogTitle>Enter Bank Details</DialogTitle>
              <DialogContent>
                <TextField label="Bank Holder Name" fullWidth margin="dense" name="BankHolderName" value={bankDetails.BankHolderName} onChange={handleBankInputChange} />
                <TextField label="Bank Name" fullWidth margin="dense" name="bankName" value={bankDetails.bankName} onChange={handleBankInputChange} />
                <TextField label="Account Number" fullWidth margin="dense" name="accountNumber" value={bankDetails.accountNumber} onChange={handleBankInputChange} />
                <TextField label="IFSC" fullWidth margin="dense" name="ifscCode" value={bankDetails.ifscCode} onChange={handleBankInputChange} />
                <TextField label="Branch" fullWidth margin="dense" name="branchName" value={bankDetails.branch} onChange={handleBankInputChange} />
                <TextField label="Bank Address" fullWidth margin="dense" name="bankAdress" value={bankDetails.bankAdress} onChange={handleBankInputChange} />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseBankModal}>Cancel</Button>
                <Button onClick={handleBankSubmit} variant="contained" color="primary">Submit</Button>
              </DialogActions>
            </Dialog>

            {/* fee Details Modal */}

            <Dialog
              open={feeModalOpen}
              onClose={handleCloseFeeModal}
              maxWidth="xs"
              fullWidth
              BackdropProps={{
                sx: {
                  backgroundColor: "rgba(0, 0, 0, 0.15)",
                  backdropFilter: "blur(1.5px)",
                },
              }}
              PaperProps={{
                sx: {
                  boxShadow: 4,
                  borderRadius: 3,
                  overflow: "hidden",
                },
              }}
            >
              <DialogTitle
                sx={{
                  fontWeight: "bold",
                  fontSize: "1.25rem",
                  bgcolor: "#a0a0a0",
                  color: "white",
                  py: 1.5,
                }}
              >
                💰 Fee Details
              </DialogTitle>

              <DialogContent dividers sx={{ bgcolor: "#fafafa" }}>
                {selectedFee ? (
                  <>{console.log("selectedFee", selectedFee)}
                    <Box sx={{ mb: 2 }}>
                      {[
                        { label: "Visa Fee", data: selectedFee?.[0].fee?.visaFee },
                        { label: "Medical Fee", data: selectedFee?.[0].fee?.medicalFee },
                        { label: "Flag Doc Fee", data: selectedFee?.[0].fee?.flagDocFee },
                      ].map((item) => (
                        <Box
                          key={item.label}
                          sx={{
                            mb: 1.5,
                            p: 1.5,
                            borderRadius: 2,
                            backgroundColor: "white",
                            border: "1px solid #e0e0e0",
                            boxShadow: "0px 1px 3px rgba(0,0,0,0.08)",
                            transition: "transform 0.2s ease",
                            "&:hover": { transform: "scale(1.02)" },
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            gutterBottom
                            sx={{ color: "primary.main" }}
                          >
                            {item.label}
                          </Typography>
                          <Typography variant="body2" sx={{ display: "flex", justifyContent: "space-between" }}>
                            <span><strong>Amount:</strong></span>
                            <span style={{ color: "#1565c0", fontWeight: 600 }}>
                              {selectedFee?.fee?.currency} {item.data?.amount ?? 0}
                            </span>
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ mt: 0.5, display: "flex", justifyContent: "space-between" }}
                          >
                            <span><strong>Remark:</strong></span>
                            <span style={{ color: "#424242", textAlign: "right" }}>
                              {item.data?.remark || "No remark"}
                            </span>
                          </Typography>
                        </Box>
                      ))}
                    </Box>

                    {/* Approval Radio Group */}
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                      Approval Status
                    </Typography>
                    <RadioGroup
                      value={approvalStatus}
                      onChange={ApprovalhandleChange}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 2,
                        mb: approvalStatus === "Not Approved" ? 1 : 0,
                      }}
                    >
                      <FormControlLabel value="Approved" control={<Radio color="success" />} label="Approve" />
                      <FormControlLabel
                        value="Not Approved"
                        control={<Radio color="error" />}
                        label="Not Approve"
                      />
                    </RadioGroup>

                    {approvalStatus === "Not Approved" && (
                      <TextField
                        label="Reason for Not Approved"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        fullWidth
                        multiline
                        rows={3}
                        placeholder="Enter reason..."
                        sx={{ backgroundColor: "white", borderRadius: 1 }}
                      />
                    )}
                  </>
                ) : (
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    No fee details available.
                  </Typography>
                )}
              </DialogContent>

              <DialogActions sx={{ p: 2, bgcolor: "#f5f5f5" }}>
                <Button onClick={handleCloseFeeModal} size="small" variant="outlined" color="inherit">
                  Cancel
                </Button>
                <Button
                  onClick={handleSave}
                  variant="contained"
                  size="small"
                  color="primary"
                  disabled={!approvalStatus || (approvalStatus === "Not Approved" && !reason.trim())}
                >
                  Save
                </Button>
              </DialogActions>
            </Dialog>


            <ToastContainer />
          </div>
        )}
      </div>
    </>
  );
};


export default ContractTable;

